export interface RecordColor {
  value: string
  color: string
  background: string
  label: string
}

export const COLORS: RecordColor[] = [
  { value: 'Red', color: '#FD4C45', background: '#FAE8E7', label: 'record.color.red' },
  { value: 'Orange', color: '#FF9045', background: '#FFECDD', label: 'record.color.orange' },
  { value: 'Yellow', color: '#FFB308', background: '#FFF7DB', label: 'record.color.yellow' },
  { value: 'Green', color: '#10BF79', background: '#E5F8F1', label: 'record.color.green' },
  { value: 'Blue', color: '#3362FF', background: '#E8EFFF', label: 'record.color.blue' },
  { value: 'Purple', color: '#7543FF', background: '#F1EBFF', label: 'record.color.purple' },
  { value: 'Pink', color: '#FF50B9', background: '#FFEBFB', label: 'record.color.pink' },
  { value: 'Lime', color: '#DDE100', background: '#FCFFDD', label: 'record.color.lime' },
  { value: 'Mint', color: '#00D4D4', background: '#EDFEFF', label: 'record.color.mint' },
  { value: 'Gray', color: '#6B7281', background: '#F3F4F6', label: 'record.color.gray' },
]

const utils = {
  COLORS,
}

export default utils
